import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { usePostFile } from '../images/usePostFile';
import { toast } from '../../../components/Toast';
import { workRegisterKeys } from './workRegisters.key';

type Options = {
  onPostPersonnelFileSuccess?: () => void;
  onPostPersonnelFileError?: (error: unknown) => void;
};

export function usePostPersonnelFile(
  personnelId: string,
  controlId: string,
  options?: Options
) {
  const getApi = useApi();
  const postFile = usePostFile();
  const queryClient = useQueryClient();

  const postPersonnelFile = async ({
    file,
    comment,
  }: {
    file: File;
    comment?: string;
  }) => {
    const api = await getApi();
    const uploaded = await postFile.mutateAsync(file);

    const res = await api.personnelCreateFile(personnelId, {
      fileId: uploaded.fileId,
      comment,
    });

    return res.data;
  };

  return useMutation(postPersonnelFile, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: workRegisterKeys.personnelFindOneFiles(controlId, personnelId),
      });
      options?.onPostPersonnelFileSuccess?.();
    },
    onError: (error: unknown) => {
      toast.error('Något gick fel, bilden gick inte att spara');
      options?.onPostPersonnelFileError?.(error);
    },
  });
}
